<template>
  <div id="app">
    <Header />
    <router-view />
  </div>
</template>

<script>
import Header from 'components/Header';
export default {
  name: 'App',
  components: {
    Header,
  },
};
</script>

<style lang="less">
@import '~normalize.css/normalize.css';
@import './styles/index.less';
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
